type ParamsType = {
  [key: string]: string
}

export enum HistoryEvents {
  PushState = 'pushstate',
  ReplaceState = 'replacestate'
}

export const getSearchParams = (url: string | URL) =>
  Object.fromEntries(new URL(url).searchParams)

export const removeParams = (params: ParamsType, keys: string[]) => {
  const res = { ...params }
  return Object.entries(res).reduce((acc, [resKey, resValue]) => {
    if (keys.includes(resKey)) {
      return acc
    }
    return { ...acc, [resKey]: resValue }
  }, {})
}

export const setParams = (params: ParamsType, key: string, value?: string) => {
  const res = {
    ...params,
    [key]: value
  }
  return Object.entries(res).reduce((acc, [resKey, resValue]) => {
    if (resKey === key) {
      if (value) {
        return { ...acc, [key]: value }
      }
      return acc
    }
    return { ...acc, [resKey]: resValue }
  }, {})
}

export const setMultipleParams = (
  params: ParamsType,
  data: {
    [key: string]: string
  }
) => {
  const res = {
    ...params,
    ...data
  }
  return Object.entries(res).reduce((acc, [resKey, resValue]) => {
    if (Object.prototype.hasOwnProperty.call(data, resKey)) {
      if (data[resKey]) {
        return { ...acc, [resKey]: data[resKey] }
      }
      return acc
    }
    return { ...acc, [resKey]: resValue }
  }, {})
}
